import { Box, HStack, Text } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { getCityDualDisplayName } from "../../utils/tripDisplay";

const TourRouteChips = ({ tourStays, t, language, isRtl }) => {
  const arrowIcon = isRtl ? faChevronRight : faChevronRight;

  return (
    <Box
      w="full"
      overflowX="auto"
      pb={1}
      css={{
        "&::-webkit-scrollbar": { height: "4px" },
        "&::-webkit-scrollbar-thumb": {
          background: "var(--chakra-colors-teal-200)",
          borderRadius: "4px",
        },
      }}
    >
      <HStack spacing={2} flexWrap={{ base: "nowrap", md: "wrap" }} minW="min-content">
        {tourStays.map((stay, index) => (
          <HStack key={`${stay.city}-${index}`} spacing={2} flexShrink={0}>
            <Box
              px={3}
              py={1.5}
              borderRadius="full"
              bg="teal.50"
              border="1px solid"
              borderColor="teal.200"
              fontSize="sm"
              fontWeight="semibold"
              color="teal.800"
              whiteSpace="nowrap"
            >
              {getCityDualDisplayName(stay.city, t, language)}
              <Text as="span" ms={2} fontWeight="normal" color="teal.600">
                ×{stay.duration}
              </Text>
            </Box>
            {index < tourStays.length - 1 && (
              <FontAwesomeIcon
                icon={arrowIcon}
                size="xs"
                color="#319795"
                style={{ transform: isRtl ? "scaleX(-1)" : undefined }}
              />
            )}
          </HStack>
        ))}
      </HStack>
    </Box>
  );
};

export default TourRouteChips;
